/* unplugin-vue-components disabled */import script from "./XUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./XUpload.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__